import type { FunctionComponent, ReactNode } from "react";
import { SdkContextProvider as ContextProvider } from "scmp-sdk";

import { createClientEnvironmentWithCred } from "scmp-app/lib/relay/environment.client";

import { useScmpSdk } from "./hooks";

export type Props = {
  children?: ReactNode;
};

export const SdkContextProvider: FunctionComponent<Props> = ({ children }) => {
  const environment = createClientEnvironmentWithCred();
  const context = useScmpSdk(environment);
  return <ContextProvider value={context}>{children}</ContextProvider>;
};

SdkContextProvider.displayName = "SdkContextProvider";
